import { APIResponse, EntityAddFormDocument, EntityConfigurationAPIPathGenerator, EntityType, EntityViewDocument } from "server-model";
import { EntityConfigurationConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerEntityConfigurationConnector extends AppServerConnector implements EntityConfigurationConnector {
    async getEntityView(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                EntityConfigurationAPIPathGenerator.detailsView(entityType),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Entity view not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createEntityView(entityViewDocument: EntityViewDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                EntityConfigurationAPIPathGenerator.createView(),
                { entityViewDocument: this.toPlain(entityViewDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create entity view")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateEntityView(organisationId: string, entityType: EntityType, entityViewDocument: EntityViewDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                EntityConfigurationAPIPathGenerator.updateView(entityType),
                { entityViewDocument: this.toPlain(entityViewDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update entity view")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteEntityView(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                EntityConfigurationAPIPathGenerator.deleteView(entityType),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete entity view")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }






    async getEntityAddForm(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                EntityConfigurationAPIPathGenerator.detailsAdd(entityType),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Entity add form not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createEntityAddForm(entityAddFormDocument: EntityAddFormDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                EntityConfigurationAPIPathGenerator.createAdd(),
                { entityAddFormDocument: this.toPlain(entityAddFormDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create entity add form")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateEntityAddForm(organisationId: string, entityType: EntityType, entityAddFormDocument: EntityAddFormDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                EntityConfigurationAPIPathGenerator.updateAdd(entityType),
                { entityAddFormDocument: this.toPlain(entityAddFormDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update entity add form")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteEntityAddForm(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                EntityConfigurationAPIPathGenerator.deleteAdd(entityType),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete entity add form")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}